enum SubSteps {
    SubStepOne = 0,
    SubStepTwo,
    SubStepThree,
    SubStepFour,
}

export default SubSteps;
